import { render, staticRenderFns } from "./Surveys.vue?vue&type=template&id=8751b60c"
import script from "./Surveys.vue?vue&type=script&lang=ts"
export * from "./Surveys.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports